import Modal from './Modal.vue'

export default {
  Modal
}



// WEBPACK FOOTER //
// ./src/components/modal/index.js